import "./pricing.css";

const PricingLayout = ({ children,name }) => {
  return <div className=
  {`pricing-inner-layout ${(name === "colorUndertone" || name === "colorInnerGrade" || name === "colorDispersion"  || name==='trueFaceUp') ? 'dark-bg-grid':name==="defaultIdu"?"defaultIdu_layout":"" }`}>{children}</div>;
};

export default PricingLayout;

